import React from 'react'
import { connect } from 'react-redux'
import { Route } from 'react-router-dom'
import { mydOauthURL} from 'config'


const MydRoute = props => {
  if (! props.isPublic && ! props.auth.isLogged) {
    window.location = mydOauthURL()
    return null
  }

  return <Route { ...props } />
}

export default connect(
  store => ({
    auth: store.auth,
  }),
)(MydRoute)
